import type { SendSeverityLevel } from '@/model/Agent.model';
import type { FC } from 'react';
import { SEVERITY_LEVEL_TEXT } from '@/components/Agents/SendValidator/utils/sendSeverity';
import styles from './sendResults.module.scss';

const badgeClass: Record<SendSeverityLevel, string> = {
  reject: styles.badgeReject,
  error: styles.badgeError,
  warning: styles.badgeWarning,
  notice: styles.badgeNotice,
  advisory: styles.badgeAdvisory,
};

const markClass: Record<SendSeverityLevel, string> = {
  reject: styles.markReject,
  error: styles.markError,
  warning: styles.markWarning,
  notice: styles.markNotice,
  advisory: styles.markAdvisory,
};

interface SendSeverityBadgeProps {
  level: SendSeverityLevel;
  className?: string;
  testId?: string;
}

/**
 * The severity level of a SEND finding as an outlined pill. Each of the five levels has its own word and
 * its own mark shape as well as its colour, so none is told apart by colour alone. Shows the server's
 * level as given; it never adds a "submission-blocking" reading of its own, which is a separate axis.
 */
const SendSeverityBadge: FC<SendSeverityBadgeProps> = ({ level, className = '', testId = 'send-severity-badge' }) => (
  <span
    className={`${styles.badge} ${badgeClass[level]} ${className}`}
    data-test-component="SendSeverityBadge"
    data-test-key={level}
    data-testid={testId}
  >
    <span className={`${styles.severityMark} ${markClass[level]}`} aria-hidden="true" />
    {SEVERITY_LEVEL_TEXT[level]}
  </span>
);

export default SendSeverityBadge;
